import type { Point } from "geojson";

export function geoPointToLatLng(json: Point): {
  lat: number;
  lng: number;
} {
  return {
    lat: json.coordinates[1],
    lng: json.coordinates[0],
  };
}

export function boundsToMinMax({
  east,
  north,
  south,
  west,
}: {
  east: number;
  north: number;
  south: number;
  west: number;
}): { min: [number, number]; max: [number, number] } {
  return {
    min: [west, south],
    max: [east, north],
  };
}
